// assets/shop-by-section.js
(function () {
  'use strict';

  function initShopBySection(section) {
    if (!section || section.dataset.initialized === 'true') return;

    const tablist = section.querySelector('.shop-by-section__tabs');
    if (!tablist) return;

    const tabs = [...section.querySelectorAll('.shop-by-section__tab')];
    const panels = [...section.querySelectorAll('.shop-by-section__panel')];

    tablist.addEventListener('click', (event) => {
      const tab = event.target.closest('.shop-by-section__tab');
      if (!tab || !tablist.contains(tab)) return;

      const { tabId } = tab.dataset;

      for (const btn of tabs) {
        const isActive = btn === tab;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', String(isActive));
      }

      for (const panel of panels) {
        panel.classList.toggle('active', panel.dataset.tabId === tabId);
      }
    });

    section.dataset.initialized = 'true';
  }

  function initializeAllSections() {
    for (const section of document.querySelectorAll('.shop-by-section:not([data-initialized="true"])')) {
      initShopBySection(section);
    }
  }

  document.addEventListener('DOMContentLoaded', initializeAllSections);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('shop-by-section')) initShopBySection(e.target);
  });
})();
